export default "__VITE_ASSET__70439943__"